import { h } from 'preact';
import * as BaseComp from 'components/bolt/ageGate/ageGate.js';
import { accessNested, joinClasses } from 'utils/utils';
import { getValueForClientSize } from 'utils/bolt';
import HTML from 'components/core/html/html';
import Button from 'components/bolt/button/button';
import Chevron from 'components/bolt/icons/chevron';
import s from 'components/bolt/ageGate/ageGate.sss';
import Cookies from 'js-cookie';
const pad2 = n => ('0' + n).slice(-2);

export default class AgeGate extends BaseComp.default {
	componentDidMount() {
		super.componentDidMount();

		const videoAccessDenied = Cookies.get('videoAccessDenied');
		if (videoAccessDenied) {
			if (videoAccessDenied === 'true') {
				this.setState({ denied: true });
				this.props.ageGateDenied();
			} else {
				this.props.throughAgeGate(true);
			}
		}
	}

	checkAge(event) {
		if (event && typeof event.preventDefault === 'function') {
			event.preventDefault();
		}

		let {
			day,
			month,
			year
		} = this.state;

		if (!day || !(month || month === 0) || !year) {
			return;
		}

		const minAge = this.props.minAge;
		let now = new Date();
		let allowedFrom = new Date((+year) + (+minAge), (+month), (+day));
		let permitted = now >= allowedFrom;

		if (permitted) {
			this.props.throughAgeGate();
		} else {
			this.setState({ denied: true });
			this.props.ageGateDenied();
		}
		this.dropCookie({ permitted });
	}

	dropCookie({ permitted }) {
		Cookies.set('videoAccessDenied', !permitted, { expires: this.props.cookieExpiry || 1 });
	}

	renderDeniedMessage(message) {
		return (
			<div class={s.denied}>
				{message}
			</div>
		);
	}

	render() {
		const {
			copy
		} = this.props;

		const { denied } = this.state;

		let {
			$AGE_GATE_DESCRIPTION = 'Please enter your own birthdate here',
			$AGE_GATE_INSTRUCTION = '',
			$AGE_GATE_CONFIRM = 'Confirm',
			$AGE_GATE_ACCESS_DENIED = 'Apologies, this page is for users over 18 only',
			$PRIVACY = 'Privacy Policy'
		} = copy.baseCopy;

		$AGE_GATE_DESCRIPTION = $AGE_GATE_DESCRIPTION.replace(/%PRIVACY%/g, $PRIVACY);

		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');

		const useShort = this.props.labels === 'short';
		let monthLabels = accessNested(copy, '$DATETIME_LOCALE.$MONTHS_FULL');
		if (useShort || !monthLabels) {
			monthLabels = [...Array(12)].map((e, i) => pad2(i + 1));
		}

		const tt = accessNested(this.props, 'appData.pages.boltHome.data.tt', {});

		let ttSrc = null;
		if (tt.desktop || tt.tablet || tt.mobile) {
			ttSrc = getValueForClientSize(tt, null, { nullIfDisabled: true });
		}

		let labelDay = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_DAY') || 'Day';
		const labelShortDay = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_SHORT_DAY') || 'DD';
		let labelMonth = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_MONTH') || 'Month';
		const labelShortMonth = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_SHORT_MONTH') || 'MM';
		let labelYear = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_YEAR') || 'Year';
		const labelShortYear = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_SHORT_YEAR') || 'YYYY';

		labelDay = labelDay.charAt(0).toUpperCase() + labelDay.slice(1);
		labelMonth = labelMonth.charAt(0).toUpperCase() + labelMonth.slice(1);
		labelYear = labelYear.charAt(0).toUpperCase() + labelYear.slice(1);


		function parse(str) {
			if (str.length) {
				return +(str);
			}
			return null;
		}

		return (
			<div class={s.videoAgeGate}>
				<div class={s.screenCover} />
				<div class={s.screenContainer}>
					<div class={s.container}>
						<div class={s.top}>
							<img
								src={ttSrc}
								class={joinClasses(s.tt)}
								alt={copy.accessibilityCopy[tt.alt] || tt.alt}
							/>
							<HTML markdown class={joinClasses(s.description, fontStyles.prefCentreDescription, denied && s.hide)}>
								{$AGE_GATE_DESCRIPTION}
							</HTML>
						</div>
						<div class={s.middle}>
							{!denied && (
								<form class={s.wrapper} onSubmit={this.checkAge}>
									<fieldset>
										<HTML markdown class={s.instruction}>
											{$AGE_GATE_INSTRUCTION}
										</HTML>
										<div class={s.inputs}>
											<div class={s.selectWrapper}>
												<select
													onChange={(e) => {
														this.setState({ month: parse(e.target.value) });
													}}
													class={s.input}
													ref={e => this.$month = e}
													required
												>
													<option value="">{useShort ? labelShortMonth : labelMonth}</option>
													{[...Array(12)].map((e, i) => <option value={i} key={i}>{monthLabels[i]}</option>)}
												</select>
												<Chevron class={s.chevron} />
											</div>
											<div class={s.selectWrapper}>
												<select
													onChange={(e) => {
														this.setState({ day: parse(e.target.value) });
													}}
													class={s.input}
													ref={e => this.$day = e}
													required
												>
													<option value="">{useShort ? labelShortDay : labelDay}</option>
													{[...Array(31)].map((e, i) => <option value={i + 1} key={i + 1}>{pad2(i + 1)}</option>)}
												</select>
												<Chevron class={s.chevron} />
											</div>
											<div class={s.selectWrapper}>
												<select
													onChange={(e) => {
														this.setState({ year: parse(e.target.value) });
													}}
													class={s.input}
													ref={e => this.$year = e}
													required
												>
													<option value="">{useShort ? labelShortYear : labelYear}</option>
													{this.renderYearOptions(useShort)}
												</select>
												<Chevron class={s.chevron} />
											</div>
										</div>
									</fieldset>
								</form>
							)}
							{denied && this.renderDeniedMessage($AGE_GATE_ACCESS_DENIED)}
						</div>
						<div class={s.bottom}>
							{!denied && (
								<Button
									disabled={!(this.state.day && (this.state.month || this.state.month === 0) && this.state.year)}
									type="primary"
									class={joinClasses(s.save, fontStyles.prefCentreSaveBtn)}
									trigger={this.checkAge}
								>
									{$AGE_GATE_CONFIRM}
								</Button>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
